var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoverplaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2100 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 2100,
    height: 600,
    fill: "#e6e7eb",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160,190h-220c-22.062,0-40,17.938-40,40v140c0,22.062,17.938,40,40,40h220c22.062,0,40-17.938,40-40v-140c0-22.062-17.938-40-40-40ZM980,230c11.044,0,20,8.956,20,20s-8.956,20-20,20-20-8.956-20-20,8.956-20,20-20ZM1148.25,362.062c-2.625,4.875-7.687,7.938-13.25,7.938h-170c-5.75,0-11-3.312-13.5-8.5-2.5-5.188-1.813-11.375,1.812-15.875l40-50c2.875-3.563,7.125-5.625,11.688-5.625s8.875,2.062,11.688,5.625l10.812,13.5,35-52.5c2.812-4.125,7.5-6.625,12.5-6.625s9.688,2.5,12.5,6.688l60,90c3.063,4.625,3.375,10.5.75,15.375Z",
    fill: "#a1a1b3",
    strokeWidth: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverplaceholder);
export default __webpack_public_path__ + "static/media/cover.placeholder.120f1e43521dd4ae83f7f5d07cc42a0b.svg";
export { ForwardRef as ReactComponent };